import {useEffect} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {ROUTES} from "../router/config";
import {useApplicationStorage} from "./useApplicationStorage";

const INTERNAL_PAGES = [ROUTES.PARENT, ROUTES.ADDRESS, ROUTES.STUDENTS, ROUTES.CONFIRMATION];

export const useRedirectIfComplete = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {applicationId} = useParams();
    const {getLead} = useApplicationStorage();

    useEffect(() => {
        const pageKey = INTERNAL_PAGES.find((key) => location.pathname.includes(key));
        const isInternalPage = !!pageKey;

        const leadData = getLead();
        if (isInternalPage && !leadData) {
            navigate("/", {replace: true});
            console.log("navigate");
        }
    }, [getLead, location.pathname]);
};
